import Image from 'next/image';

interface TextImageBlockProps {
  title?: string;
  isHero?: boolean;
  content: string;
  image?: string;
  fill: boolean;
  position?: string;
}

export const TextImageBlock = ({
  title,
  isHero = false,
  content,
  image,
  fill = false,
  position = 'center',
}: TextImageBlockProps) => {
  const imageClasses = [
    'w-full',
    `${fill ? 'object-cover' : 'object-contain'}`,
    'max-h-40',
    `${fill ? 'max-h-40' : 'max-h-full'}`,
    'lg:h-full',
    'lg:max-h-full',
  ].join(' ');
  return (
    <>
      <div className="gap-large flex flex-col-reverse py-6 pt-0 lg:flex-row lg:pt-6">
        <div className="flex grow basis-full flex-col">
          {title && isHero && <h1 className="mt-0">{title}</h1>}
          {title && !isHero && <h2 className="mt-0">{title}</h2>}
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
        <div className="-mx-4 -mt-4 grow basis-full lg:mx-auto lg:mt-0">
          {image && (
            // Object-position does not work as expected with Tailwind so using style here.
            <Image
              role="presentation"
              alt=""
              className={imageClasses}
              src={image}
              width={600}
              height={0}
              sizes="(max-width: 786px) 100vw, 50vw"
              style={{ objectPosition: position }}
              priority
              fetchPriority="high"
              quality={90}
            />
          )}
        </div>
      </div>
    </>
  );
};
